import { render, staticRenderFns } from "./OrganizationPlan.vue?vue&type=template&id=1b1e74ca&lang=pug&"
import script from "./OrganizationPlan.vue?vue&type=script&lang=js&"
export * from "./OrganizationPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports